{
  "cp.components.appDrawer.drawerCourses": "Courses",
  "cp.components.appDrawer.drawerExport": "Export",
  "cp.components.appDrawer.drawerImprint": "Terms",
  "cp.components.appDrawer.drawerInstitutes": "Institutes",
  "cp.components.appDrawer.drawerSettings": "Settings",
  "cp.components.appDrawer.drawerShares": "Shares",
  "cp.components.appDrawer.drawerSingleTrainings": "Trainings",
  "cp.components.appDrawer.drawerTrainees": "Trainees",
  "cp.components.appDrawer.drawerTrainers": "Trainers",
  "cp.components.changePassword.changePasswordButton": "Change password",
  "cp.components.changePassword.currentPassword": "Current password",
  "cp.components.changePassword.equalError": "The new password is the same as the old one",
  "cp.components.changePassword.matchError": "New passwords don't match",
  "cp.components.changePassword.newPassword": "New password",
  "cp.components.changePassword.newPasswordRepeat": "New password (repeat)",
  "cp.components.changePassword.newRequiredError": "A new password is required",
  "cp.components.changePassword.newToShortError": "The provided password is too short.",
  "cp.components.changePassword.requiredError": "The current password is required",
  "cp.components.changePassword.setPasswordButton": "Set password",
  "cp.components.changeUserRole.errorSnackbar": "An unknown error occured. Please try again or contact the support if the error persists.",
  "cp.components.changeUserRole.selectLabel": "Choose role",
  "cp.components.changeUserRole.successSnackbar": "Changed role to {role}",
  "cp.components.courseTable.deleteLabel": "delete",
  "cp.components.courseTable.downloadCSVTitle": "Download CSV file",
  "cp.components.courseTable.downloadMessage": "Course selected for download",
  "cp.components.courseTable.selected": "selected",
  "cp.components.courseTable.tableRowAssociatedTrainer": "Associated Trainer",
  "cp.components.courseTable.tableRowDate": "Date",
  "cp.components.courseTable.tableRowIdentifier": "Course ID",
  "cp.components.courseTable.tableRowLocation": "Location",
  "cp.components.courseTable.tableRowProvider": "Training Provider",
  "cp.components.courseTable.tableRowTraineeCount": "Trainee count",
  "cp.components.courseTable.tableRowValue": "Value",
  "cp.components.dialog.confirmDeletion.contentConclusion": "The deletion is permanent. This account will no longer be available.",
  "cp.components.dialog.confirmDeletion.contentDescription": "You are about to delete an account with the following role(s):",
  "cp.components.dialog.confirmDeletion.title": "Delete selected account?",
  "cp.components.footer.rightsReserved": "All rights reserved.",
  "cp.components.general.institutePageSnackbarError": "Error saving institute",
  "cp.components.general.institutePageSnackbarSuccess": "Saved",
  "cp.components.general.snackbar.emailAllreadySentSnackbar": "The E-Mail has been sent within the last 10 minutes. Please wait before you can send another one.",
  "cp.components.general.tableRowName": "Name",
  "cp.components.genericTable.emptyMessage": "Empty",
  "cp.components.genericTable.multiSelect": "select all",
  "cp.components.genericTable.nextPage": "next page",
  "cp.components.genericTable.previousPage": "previous page",
  "cp.components.genericTable.rowsPerPageLabel": "Rows per page:",
  "cp.components.genericTable.searchPlaceholder": "Search",
  "cp.components.imprint.pageTitle": "Terms of use",
  "cp.components.instituteAdminTable.adminsTableEmail": "Email",
  "cp.components.instituteAdminTable.adminsTableInviteButton": "Invite Admin",
  "cp.components.instituteAdminTable.adminsTableSubtitle": "Users allowed to manage the institute",
  "cp.components.instituteAdminTable.adminsTableTitle": "Admins",
  "cp.components.instituteAdminTable.deleteAdminMessage": "Do you really want to delete the selected admin? This will be permanent.",
  "cp.components.instituteAdminTable.deleteLabel": "delete",
  "cp.components.instituteAdminTable.deleteTrainerMessage": "Do you really want to delete the selected trainer? This will be permanent.",
  "cp.components.instituteAdminTable.name": "Name",
  "cp.components.instituteAdminTable.selected": "selected",
  "cp.components.instituteForm.institute": "Institute",
  "cp.components.instituteForm.instituteAddress": "Institute Address",
  "cp.components.instituteForm.instituteCity": "City",
  "cp.components.instituteForm.instituteCountry": "Country",
  "cp.components.instituteForm.instituteName": "Name of the institute",
  "cp.components.instituteForm.instituteSaveButton": "Save",
  "cp.components.instituteForm.instituteState": "State",
  "cp.components.instituteForm.instituteStreet": "Street and house number",
  "cp.components.instituteForm.instituteStreetAdditional": "Addition to address",
  "cp.components.instituteForm.instituteZIP": "ZIP code",
  "cp.components.instituteForm.localeDanish": "Dansk",
  "cp.components.instituteForm.localeEnglish": "English",
  "cp.components.instituteForm.localeFinish": "Suomi",
  "cp.components.instituteForm.localeFrench": "Français",
  "cp.components.instituteForm.localeGerman": "Deutsch",
  "cp.components.instituteForm.localeItalian": "Italiano",
  "cp.components.instituteForm.localeLabel": "Language",
  "cp.components.instituteForm.localeSpanish": "Espanol",
  "cp.components.instituteResultConfig.button": "Configure result feedback",
  "cp.components.instituteResultConfig.info": "These changes are applied to the entire institute. For this to happen, the trainers have to log in to the CorPatch® Trainer app again. ",
  "cp.components.instituteResultConfig.save": "Save Configuration",
  "cp.components.instituteResultConfig.thresholdGood": "Threshold Good",
  "cp.components.instituteResultConfig.thresholdGreat": "Threshold Great",
  "cp.components.instituteTrainerTable.button": "Invite Trainer",
  "cp.components.instituteTrainerTable.deleteLabel": "delete",
  "cp.components.instituteTrainerTable.name": "Name",
  "cp.components.instituteTrainerTable.selected": "selected",
  "cp.components.instituteTrainerTable.subtitle": "All trainers belonging to the institute\n",
  "cp.components.instituteTrainerTable.tableRowsStreet": "Street",
  "cp.components.instituteTrainerTable.title": "Trainers",
  "cp.components.instituteTrainerTable.trainerEmptyMessage": "No trainers yet",
  "cp.components.invite.inviteCancelButton": "Cancel",
  "cp.components.invite.inviteEmailRequired": "Email",
  "cp.components.invite.inviteEmailSend": "Sent",
  "cp.components.invite.inviteEmailSent": "Email sent.",
  "cp.components.invite.inviteFirstnameLabel": "First name",
  "cp.components.invite.inviteInvalidEmail": "This is not an valid email address",
  "cp.components.invite.inviteOk": "OK",
  "cp.components.invite.inviteSendButton": "Send Invitation",
  "cp.components.invite.inviteSubheader": "An invitation will be send to this email address.",
  "cp.components.invite.inviteSurnameLabel": "Family name",
  "cp.components.navBar.menuLabel": "menu",
  "cp.components.passwordForgotSetPassword.changePasswordButton": "Change Password",
  "cp.components.passwordForgotSetPassword.matchError": "New passwords don't match",
  "cp.components.passwordForgotSetPassword.newPassword": "New password",
  "cp.components.passwordForgotSetPassword.newPasswordRepeat": "New password (repeat)",
  "cp.components.passwordForgotSetPassword.newRequiredError": "A new password is required",
  "cp.components.passwordForgotSetPassword.newToShortError": "The provided password is too short.",
  "cp.components.reminder.app.appAppStoreButton": "Go to Apple App Store",
  "cp.components.reminder.app.appPlayStoreButton": "Go to Google Play Store",
  "cp.components.reminder.app.content": "To use your CorPatch®, you need the CorPatch® app. Download it from the Google Playstore or App Store. \n",
  "cp.components.reminder.app.title": "Want to start? Download the App!",
  "cp.components.reminder.title": "CorPatch®",
  "cp.components.reminder.welcome": "Welcome",
  "cp.components.resetPassword.changePasswordButton": "Change password",
  "cp.components.resetPassword.currentPassword": "Current password",
  "cp.components.resetPassword.equalError": "The new password is the same as the old one",
  "cp.components.resetPassword.matchError": "New passwords don't match",
  "cp.components.resetPassword.newPassword": "New password",
  "cp.components.resetPassword.newPasswordRepeat": "New password (repeat)",
  "cp.components.resetPassword.newRequiredError": "A new password is required",
  "cp.components.resetPassword.requiredError": "The current password is required",
  "cp.components.resetPassword.setPasswordButton": "Set password",
  "cp.components.singleTrainingsTable.shareDialogContent": "Select the institute you want to share this training with:",
  "cp.components.singleTrainingsTable.shareDialogTitle": "Share training",
  "cp.components.singleTrainingsTable.shareDialogTooltip": "Share training",
  "cp.components.singleTrainingsTable.sharedDialogCancelButton": "Cancel",
  "cp.components.singleTrainingsTable.sharedDialogShareButton": "Share",
  "cp.components.singleTrainingsTable.sharedDialogTooltip": "Shared at: ",
  "cp.components.singleTrainingsTable.tableRowDate": "Date",
  "cp.components.singleTrainingsTable.tableRowDepth": "Depth",
  "cp.components.singleTrainingsTable.tableRowFlow": "Flow",
  "cp.components.singleTrainingsTable.tableRowFrequency": "Frequency",
  "cp.components.singleTrainingsTable.tableRowOrigin": "Training",
  "cp.components.singleTrainingsTable.tableRowRecoil": "Recoil",
  "cp.components.singleTrainingsTable.tableShareTrainingTooltip": "Share training",
  "cp.components.userMenu.email": "Email",
  "cp.components.userMenu.logout": "Logout",
  "cp.components.userMenu.password": "Password",
  "cp.pages.acceptInvitation.button": "To the login page",
  "cp.pages.acceptInvitation.message": "All set and you are good to go!",
  "cp.pages.acceptInvitation.pageNotFound.message": "This invitation is not valid anymore.",
  "cp.pages.acceptInvitation.pageNotFound.title": "Invitation not found",
  "cp.pages.acceptInvitation.title": "Done.",
  "cp.pages.acceptInvitation.welcome": "Welcome",
  "cp.pages.adminInvite.errorSnackbar": "Email {email} is already in use",
  "cp.pages.adminInvite.inviteCardTitle": "Invite admin",
  "cp.pages.adminInvite.successSnackbar": "Email send to {email}",
  "cp.pages.admins.adminsEmpty.button": "Invite admin",
  "cp.pages.admins.adminsEmpty.message": "Do you want to invite the first institute admin?",
  "cp.pages.admins.adminsEmpty.selected": "selected",
  "cp.pages.admins.adminsEmpty.tableRowEmail": "Email",
  "cp.pages.admins.adminsEmpty.tableRowName": "Name",
  "cp.pages.admins.adminsEmpty.title": "No admins yet!",
  "cp.pages.admins.adminsNotFound.message": "This institute has been deleted. ",
  "cp.pages.admins.adminsNotFound.title": "Not found!",
  "cp.pages.admins.instituteAdmin": "Institute Admin",
  "cp.pages.admins.tableRowInstitute": "Institute",
  "cp.pages.admins.title": "Admins",
  "cp.pages.course.cellDate": "Date",
  "cp.pages.course.cellDuration": "Duration",
  "cp.pages.course.cellFeedback": "Feedback",
  "cp.pages.course.cellName": "Name",
  "cp.pages.course.rowDepth": "Depth",
  "cp.pages.course.rowFlow": "Flow",
  "cp.pages.course.rowFrequency": "Frequency",
  "cp.pages.course.rowRecoil": "Recoil",
  "cp.pages.course.title": "Course",
  "cp.pages.course.trainees": "Trainees",
  "cp.pages.courses.errorSnackbar": "This course could not be deleted.",
  "cp.pages.courses.pageNotFoundMessage": "Was deleted. Sorry :(",
  "cp.pages.courses.pageNotFoundTitle": "not found",
  "cp.pages.courses.pageTitle": "Courses",
  "cp.pages.courses.roleInstituteAdmin": "Institute admin",
  "cp.pages.courses.roleTrainee": "Trainee",
  "cp.pages.courses.successSnackbar": "Course has been deleted successfully.",
  "cp.pages.dashboard.cpsCount": "active CorPatch® devices",
  "cp.pages.dashboard.cpsCountRecently": "new CorPatch® connected",
  "cp.pages.dashboard.lastMonth": "Development over the last month.",
  "cp.pages.dashboard.mobilesCount": "All mobiles recognized",
  "cp.pages.dashboard.mobilesCountRecently": "recent mobiles",
  "cp.pages.dashboard.pageTitle": "Statistics",
  "cp.pages.dashboard.trainingsCount": "trainings completed",
  "cp.pages.dashboard.usersCount": "total amount of registered users",
  "cp.pages.dashboard.usersCountRecently": "new users registered",
  "cp.pages.email.validation.button": "Go to Login",
  "cp.pages.email.validation.text": "Thank you for verifying your email address. We will use it to keep your account secure and keep you up to date if you wish.",
  "cp.pages.export.pageTitle": "Export course",
  "cp.pages.homepage.title": "Home Page",
  "cp.pages.institute.PageNotFound.message": "This institute has been deleted and cannot be edited anymore.",
  "cp.pages.institute.PageNotFound.title": "Institute not found.",
  "cp.pages.institute.institute": "Institute",
  "cp.pages.institute.snackbarError": "Error saving institute",
  "cp.pages.institute.snackbarSuccess": "Saved",
  "cp.pages.institute.tabsAdmins": "Admins",
  "cp.pages.institute.tabsBaseData": "Basis data",
  "cp.pages.institute.tabsTrainers": "Trainers",
  "cp.pages.instituteAdminShares.active": "Active",
  "cp.pages.instituteAdminShares.deleted": "Deleted",
  "cp.pages.instituteAdminShares.endDate": "End: ",
  "cp.pages.instituteAdminShares.noActiveSharingObjectsMessage": "You have no active sharing objects.",
  "cp.pages.instituteAdminShares.noDeletedSharingObjectsMessage": "No deleted sharing objects.",
  "cp.pages.instituteAdminShares.pageNotFoundMessage": "The shares you are looking for do not exists.",
  "cp.pages.instituteAdminShares.pageTitle": "Shares",
  "cp.pages.instituteAdminShares.pageTitleNotFound": "Not found",
  "cp.pages.instituteAdminShares.startDate": "Start: ",
  "cp.pages.institutes.addInstituteButton": "Add institute",
  "cp.pages.institutes.deleteLabel": "delete",
  "cp.pages.institutes.errorSnackbar": "Institute could not be deleted",
  "cp.pages.institutes.pageNotFound.message": "Do you want to add the first institute?",
  "cp.pages.institutes.pageNotFound.title": "No institute found",
  "cp.pages.institutes.pageTitle": "Institutes",
  "cp.pages.institutes.successSnackbar": "Institute was deleted successfully.",
  "cp.pages.institutesTable.deleteWarning": "Do you want to delete the selected institute? All associated accounts and data will be lost!",
  "cp.pages.institutesTable.instituteLowercase": "institute",
  "cp.pages.institutesTable.institutesLowercase": "institutes",
  "cp.pages.institutesTable.tableRowCity": "City",
  "cp.pages.institutesTable.tableRowCountry": "Country",
  "cp.pages.institutesTable.tableRowInstitutes": "Institutes",
  "cp.pages.institutesTable.tableRowName": "Name",
  "cp.pages.institutesTable.tableRowStreet": "Street",
  "cp.pages.institutesTable.tableRowZIP": "ZIP",
  "cp.pages.internalServerError.button": "Try again",
  "cp.pages.internalServerError.message": "The server was not able to complete the request. This is on us. Please try again later.",
  "cp.pages.internalServerError.title": "Please, try again later.",
  "cp.pages.login.email": "Email",
  "cp.pages.login.loginButton": "Login",
  "cp.pages.login.loginInstitutesTitle": "Institutes",
  "cp.pages.login.password": "Password",
  "cp.pages.login.passwordForgot": "Forgot password?",
  "cp.pages.login.registerButton": "Register",
  "cp.pages.login.termsOfUseButton": "Terms of use",
  "cp.pages.login.userNewlyRegisteredLabel1": "You have been registered successfully.",
  "cp.pages.login.userNewlyRegisteredLabel2": "Don't forget to confirm your email address and log in right away.",
  "cp.pages.login.userOrPasswordNotFound": "User or password not found",
  "cp.pages.login.validate.errorContent": "Maybe you have tried to login from another browser or device or you have closed your browser in the meantime. Try to request another E-Mail to login.",
  "cp.pages.login.validate.errorSnackbar": "There was an error with logging you in. Your link might be outdated.",
  "cp.pages.login.validate.errorTitle": "We could not recognize your browser session",
  "cp.pages.login.validate.successContent": "Please wait a moment while we validate your login.",
  "cp.pages.login.validate.successTitle": "We are logging you in.",
  "cp.pages.login.validate.validationButton": "Go back to login",
  "cp.pages.login.validate.validationContent": "We have sent you an E-Mail to verify your login.",
  "cp.pages.login.validate.validationTitle": "Please verify your login",
  "cp.pages.logout.loginButton": "LOGIN",
  "cp.pages.logout.message": "See you next time",
  "cp.pages.logout.title": "Goodbye!",
  "cp.pages.me.deleteOwnButtonConfirm": "Delete your account permanently",
  "cp.pages.me.deleteOwnButtonRequest": "Delete your account permenantly",
  "cp.pages.me.deleteOwnContent": "This action will delete your account permanently. Please be confident that you have saved any data that might get lost when deleting your account. Be advised that you can not reverse this action.",
  "cp.pages.me.familyName": "Family name",
  "cp.pages.me.firstName": "First name",
  "cp.pages.me.gender": "Gender",
  "cp.pages.me.genderFemale": "Female",
  "cp.pages.me.genderMale": "Male",
  "cp.pages.me.genderOther": "Other",
  "cp.pages.me.notFoundTitle": "Account settings",
  "cp.pages.me.save": "Save",
  "cp.pages.me.snackBarSaved.error": "Error saving account settings ",
  "cp.pages.me.snackBarSaved.saved": "Saved",
  "cp.pages.me.title": "Account settings",
  "cp.pages.networkError.pageNotFound.button": "Try again",
  "cp.pages.networkError.pageNotFound.message": "The server was not able to complete the request. Are you connected to the Internet?",
  "cp.pages.networkError.pageNotFound.title": "The server seems to be down. This is on us! Please give it a retry later. ",
  "cp.pages.notFound.message": "Could not find this page.",
  "cp.pages.notFound.title": "Not found.",
  "cp.pages.passwordForgot.confirmationMessage": "The verification email will be sent to your account.",
  "cp.pages.passwordForgot.confirmationMessage2": "Please check it.",
  "cp.pages.passwordForgot.confirmationSendMessage": "We sent you an email with an approval link to",
  "cp.pages.passwordForgot.confirmationSent": "Send email",
  "cp.pages.passwordForgot.confirmationTitle": "Reset your password",
  "cp.pages.passwordForgot.eMail": "Email",
  "cp.pages.passwordForgot.passwordForgotBackToLogin": "Back to login",
  "cp.pages.passwordForgot.passwordForgotTitle": "Password forgotten ",
  "cp.pages.passwordForgotSetPassword.button": "To the login page",
  "cp.pages.passwordForgotSetPassword.message": "All set up and you are good to go!",
  "cp.pages.passwordForgotSetPassword.pageNotFound.message": "This code is not valid anymore.",
  "cp.pages.passwordForgotSetPassword.pageNotFound.title": "Not valid anymore",
  "cp.pages.passwordForgotSetPassword.title": "Password changed!",
  "cp.pages.passwordForgotSetPassword.welcome": "Welcome",
  "cp.pages.register.acceptTermsOfUse": "Do you accept the terms of use?",
  "cp.pages.register.create": "Create Account",
  "cp.pages.register.emailField": "Email",
  "cp.pages.register.errorSnackbar": "An unintended error occured. Please try again.",
  "cp.pages.register.firstnameField": "First name",
  "cp.pages.register.lastnameField": "Last name",
  "cp.pages.register.newToShortError": "The provided password is too short.",
  "cp.pages.register.passwordField": "password",
  "cp.pages.register.successSnackbar": "You registration was successful.",
  "cp.pages.settings.feedbackMode.menuItemExpert": "Bar",
  "cp.pages.settings.feedbackMode.menuItemNone": "None",
  "cp.pages.settings.feedbackMode.menuItemSimple": "Pump",
  "cp.pages.settings.menuItemThresholdGood": "Threshold Feedback \"Good\"",
  "cp.pages.settings.menuItemThresholdGreat": "Threshold Feedback \"Great\"",
  "cp.pages.settings.resultType.menuItemExpert": "Expert",
  "cp.pages.settings.resultType.menuItemNone": "None",
  "cp.pages.settings.resultType.menuItemSimple": "Simple",
  "cp.pages.settings.resultType.menuItemStandard": "Standard",
  "cp.pages.settings.tableRowCompression": "Compressions only",
  "cp.pages.settings.tableRowDuration": "Session duration",
  "cp.pages.settings.tableRowERC": "Check for vital signs",
  "cp.pages.settings.tableRowFeedback": "Feedback mode",
  "cp.pages.settings.tableRowFrequency": "Target frequency",
  "cp.pages.settings.tableRowLocked": "Locked",
  "cp.pages.settings.tableRowProperty": "Property",
  "cp.pages.settings.tableRowResult": "Result type",
  "cp.pages.settings.tableRowResultConfigSaveButton": "Save result configuration",
  "cp.pages.settings.tableRowSaveButton": "Save",
  "cp.pages.settings.tableRowTrainees": "Default number of trainees",
  "cp.pages.settings.tableRowType": "Session type",
  "cp.pages.settings.tableRowValue": "Value",
  "cp.pages.settings.title": "Settings for CorPatch® Trainer",
  "cp.pages.sharingObject.form.apiAccess": "API Access",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage1": "Are you sure you want to delete the sharing object?",
  "cp.pages.sharingObject.form.confirmDeleteDialogMessage2": "This action cannot be undone, but no data will be lost. The sharing object will be shown as deactivated.",
  "cp.pages.sharingObject.form.confirmDeleteDialogNo": "Cancel",
  "cp.pages.sharingObject.form.confirmDeleteDialogTitle": "Remove Sharing Object",
  "cp.pages.sharingObject.form.confirmDeleteDialogYes": "Delete",
  "cp.pages.sharingObject.form.deleteButton": "Delete",
  "cp.pages.sharingObject.form.disabled": "Disabled",
  "cp.pages.sharingObject.form.enabled": "Enabled",
  "cp.pages.sharingObject.form.invitationCode": "Invitation Code",
  "cp.pages.sharingObject.form.invitationLink": "Invitation Link",
  "cp.pages.sharingObject.form.name": "Name",
  "cp.pages.sharingObject.form.pullApiSecret": "Secret",
  "cp.pages.sharingObject.form.pullUrl": "Pull URL",
  "cp.pages.sharingObject.form.saveButton": "Save",
  "cp.pages.sharingObject.form.title": "Sharing object",
  "cp.pages.sharingObject.form.webHook": "WebHook",
  "cp.pages.sharingObject.pageNotFoundDescription": "The sharing objects you are looking for do not exists.",
  "cp.pages.sharingObject.pageNotFoundTitle": "Not found",
  "cp.pages.sharingObject.pageTitle": "Sharing Objects",
  "cp.pages.sharingObject.snackBarDeleteError": "Could not delete",
  "cp.pages.sharingObject.snackBarDeleted": "Deleted",
  "cp.pages.sharingObject.snackBarSaveError": "Could not save",
  "cp.pages.sharingObject.snackBarSaved": "Saved",
  "cp.pages.singleTraining.multipleTrainings": "trainings",
  "cp.pages.singleTraining.singleTraining": "training",
  "cp.pages.singleTraining.table.created": "Created",
  "cp.pages.singleTraining.table.name": "Full Name",
  "cp.pages.singleTraining.table.selected": "selected",
  "cp.pages.singleTraining.title": "Your trainings",
  "cp.pages.trainee.cpsButton": "Download CorPatch® data",
  "cp.pages.trainee.delete.errorSnackbar": "An unknown error occured",
  "cp.pages.trainee.delete.successSnackbar": "Trainees deleted successfully",
  "cp.pages.trainee.delete.warningSnackbar": "One or more users were not deleted",
  "cp.pages.trainee.deleteDialogButtonPrimary": "Delete",
  "cp.pages.trainee.deleteDialogButtonSecondary": "Close",
  "cp.pages.trainee.deleteLabel": "delete",
  "cp.pages.trainee.mobileButton": "Smartphone data-download",
  "cp.pages.trainee.multipleTrainees": "trainees",
  "cp.pages.trainee.singleTrainee": "trainee",
  "cp.pages.trainee.table.created": "Created",
  "cp.pages.trainee.table.email": "E-Mail",
  "cp.pages.trainee.table.name": "Full name",
  "cp.pages.trainee.table.selected": "selected",
  "cp.pages.trainee.title": "Trainees",
  "cp.pages.traineeShares.active": "Active",
  "cp.pages.traineeShares.addDialogAdd": "Add",
  "cp.pages.traineeShares.addDialogCancel": "Cancel",
  "cp.pages.traineeShares.addDialogDescription": "Enter the invitation code you got from your partner organization:",
  "cp.pages.traineeShares.addDialogDescription2": "If you choose to click \"Add,\" you are acknowledging that you agree to the terms and conditions and privacy policy provided to you by the partner organization along with this invitation link/code. It is essential to read and understand these before proceeding.",
  "cp.pages.traineeShares.addDialogTitle": "Invitation",
  "cp.pages.traineeShares.addShare": "Add Share",
  "cp.pages.traineeShares.deactivateDialogDescription": "Are you sure you want to deactivate this sharing agreement with {instituteName}?",
  "cp.pages.traineeShares.deactivateDialogNo": "Cancel",
  "cp.pages.traineeShares.deactivateDialogTitle": "Deactivate",
  "cp.pages.traineeShares.deactivateDialogYes": "Deactivate",
  "cp.pages.traineeShares.deactivateTooltip": "Deactivate",
  "cp.pages.traineeShares.endDate": "End date: ",
  "cp.pages.traineeShares.inactive": "Inactive",
  "cp.pages.traineeShares.noActiveItemsMessage": "Currently, you have not agreed to any data sharing agreements. Press the plus button at the bottom right to enter a corresponding invitation code.",
  "cp.pages.traineeShares.noInactiveItemsMessage": "No in-active sharing agreements.",
  "cp.pages.traineeShares.pageNotFoundMessage": "The trainee shares you are looking for do not exists.",
  "cp.pages.traineeShares.pageTitle": "Trainee Shares",
  "cp.pages.traineeShares.pageTitleNotFound": "Not found",
  "cp.pages.traineeShares.snackBarErrorAddingInvitation": "Error adding invitation: {errorMessage}!",
  "cp.pages.traineeShares.snackBarErrorDeactivatingSharing": "Error deactivating sharing: {errorMessage}!",
  "cp.pages.traineeShares.snackBarInvalidCode": "Please enter a valid invitation code.",
  "cp.pages.traineeShares.snackBarInvitationAdded": "Invitation added",
  "cp.pages.traineeShares.snackBarSharingDeactivated": "Sharing deactivated",
  "cp.pages.traineeShares.startDate": "Start date: ",
  "cp.pages.trainerInvite.errorSnackbar": "Email is already in use",
  "cp.pages.trainerInvite.successSnackbar": "Email send to {email}",
  "cp.pages.trainerInvite.title": "Invite trainer",
  "cp.pages.trainers.errorSnackbar": "The user could not be deleted. Please try again!",
  "cp.pages.trainers.successSnackbar": "Deleted.",
  "cp.pages.trainersNotAvailable.button": "Invite trainer",
  "cp.pages.trainersNotAvailable.message": "Do you want to invite the first trainer?",
  "cp.pages.trainersNotAvailable.title": "No trainers yet!",
  "cp.pages.trainersNotFound.message": "This trainer has been deleted. Sorry :(",
  "cp.pages.trainersNotFound.title": "Trainer not found",
  "cp.pages.trainersTable.deleteLabel": "delete",
  "cp.pages.trainersTable.inviteTrainer": "Invite Trainer",
  "cp.pages.trainersTable.selected": "selected",
  "cp.pages.trainersTable.tableRowEmail": "E-Mail",
  "cp.pages.trainersTable.tableRowName": "Name",
  "cp.pages.trainersTable.trainers": "Trainers",
  "cp.pages.trainings.depth": "Depth",
  "cp.pages.trainings.flow": "Flow",
  "cp.pages.trainings.frequency": "Frequency",
  "cp.pages.trainings.notFound.message": "Has been deleted already. Sorry.",
  "cp.pages.trainings.notFound.title": "Not found",
  "cp.pages.trainings.recoil": "Recoil",
  "cp.pages.trainings.title": "Trainings",
  "cp.pages.trainings.trainee": "Trainee",
  "cp.pages.trainings.trainingNumber": "Training No.",
  "cp.pages.userChangeEmail.cancelButton": "Cancel",
  "cp.pages.userChangeEmail.changeEmail": "Change email",
  "cp.pages.userChangeEmail.email": "Email",
  "cp.pages.userChangeEmail.emailChangedSnackbar": "Email changed",
  "cp.pages.userChangeEmail.emailErrorSnackbar": "Could not change email",
  "cp.pages.userChangeEmail.newEmail": "New email",
  "cp.pages.userChangeEmail.notFound.message": "This user does not exist anymore.",
  "cp.pages.userChangeEmail.notFound.title": "Not found.",
  "cp.pages.userChangeEmail.ok": "OK",
  "cp.pages.userChangeEmail.sendEmail": "Email sent",
  "cp.pages.userChangeEmail.verifyEmail.button": "Send me a new verification E-Mail to my address",
  "cp.pages.userChangeEmail.verifyEmail.content": "We want to keep you informed about the latest changes to our app and products. Therefore we need to verify your E-Mail address.",
  "cp.pages.userChangeEmail.verifyEmail.title": "Please verify your E-Mail",
  "cp.pages.userChangePassword.notChangedPasswordSnackbar": "Could not change password:",
  "cp.pages.userChangePassword.notFound.message": "This user has been deleted.",
  "cp.pages.userChangePassword.notFound.title": "User not found. ",
  "cp.pages.userChangePassword.successSnackbar": "Password changed",
  "cp.pages.userChangePassword.title": "Change password",
  "cp.pages.userChangePassword.wrongPasswordSnackbar": "Current password is wrong",
  "cp.pages.userDetails.errorSnackbar": "The invitation could not be sent. ",
  "cp.pages.userDetails.invitation": "Invitation",
  "cp.pages.userDetails.notFound.message": "This information was deleted. ",
  "cp.pages.userDetails.notFound.title": "Not Found",
  "cp.pages.userDetails.sendInvitation": "Send Invitation",
  "cp.pages.userDetails.signUpAccepted": "Accepted",
  "cp.pages.userDetails.signUpPending": "Pending",
  "cp.pages.userDetails.successSnackbar": "Invitation sent",
  "cp.pages.userDetails.userDetailsEmail": "E-Mail"
}